import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";

interface FloatingInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label: string;
  registration?: UseFormRegisterReturn; // optional to allow non-hook usage
  error?: string;
  className?: string;
}

const FloatingInput: React.FC<FloatingInputProps> = ({
  id,
  label,
  registration,
  error,
  className = "",
  ...rest
}) => {
  return (
    <div className="relative floating-group">
      <input
        id={id}
        placeholder=" "
        {...(registration || {})}
        {...rest}
        className={`peer block w-full rounded-xl border bg-white/70 dark:bg-secondary-800/60 dark:border-secondary-600/60 border-secondary-300/80 px-3 pt-6 pb-2 text-base text-gray-900 dark:text-white placeholder-transparent shadow-sm focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500/40 dark:focus:border-primary-500/70 dark:focus:ring-primary-500/30 transition ${
          error ? "field-error" : ""
        } ${className}`}
        aria-invalid={!!error || undefined}
        aria-describedby={error ? `${id}-error` : undefined}
      />
      <label
        htmlFor={id}
        className={`pointer-events-none absolute left-3 top-2 origin-[0] -translate-y-0 text-xs font-medium tracking-wide text-gray-500 dark:text-gray-400 transition-all duration-150 ease-out floating-label ${
          error
            ? "text-red-600 dark:text-red-400 peer-focus:text-red-600 dark:peer-focus:text-red-400"
            : ""
        }`}
      >
        {label}
      </label>
      {error && (
        <p id={`${id}-error`} className="error-message mt-1">
          {error}
        </p>
      )}
    </div>
  );
};

export default FloatingInput;
